import { trackEvent } from "src/utils/api/tracker";
import { RecommendedPlanState } from "@utils/redux/slices/recommendedPlan";
import { getTrialInfo } from "./trialFee";
import { ServerContextState } from "src/utils/redux/slices/serverContext";

export const decoratePurchaseRequestWithProductCatalog = (
  purchaseRequest: JsonObject,
  recommendedPlan: RecommendedPlanState,
  serverContext: ServerContextState
) => {
  const trialFee = recommendedPlan.trial_fee;
  const trialSaleItem = recommendedPlan?.trial_item_options?.find(
    (trial) => trial.price === trialFee
  );
  const trialSaleItemId = trialSaleItem?.trial_sale_item_id;

  // equality comparison coerces null<->undefined
  if (trialFee != null && trialSaleItemId === null) {
    trackEvent("ProductAsPlanTrialMismatch", {
      recommendedPlan,
      trialFee,
    });
  }

  const { hasTrial, trackingData } = getTrialInfo(
    recommendedPlan,
    serverContext
  );
  if (trialSaleItemId && !hasTrial) {
    trackEvent("ProductAsPlanMissingLegacyTrial", {
      recommendedPlan,
      trialInfo: trackingData,
    });
  }

  let newPurchaseRequest = {
    ...purchaseRequest,
    subscriptionSaleItemId: recommendedPlan?.sale_item_id,
  };

  if (hasTrial) {
    newPurchaseRequest = {
      ...newPurchaseRequest,
      trialSaleItemId,
      trialFee: recommendedPlan.trial_fee,
    };
  }
  return newPurchaseRequest;
};
